import React, { useContext } from 'react'

import { BoardStoreContext } from '../../contexts'
import BoardStore from '../../store/BoardStore'

const useBoardStore = (): BoardStore => {
   const boardStore = useContext(BoardStoreContext)

   if (!boardStore) {
      throw new Error('Expected to be wrapped in Board Store Provider')
   }

   return boardStore
}

export { useBoardStore }
